import { Box, Paper, Skeleton, Stack } from "@mui/material";
import React from "react";
import { SwiperSlide } from "swiper/react";
import { useCoreRequestProvider } from "../../providers/RequestProvider";
import {
  LinkValues,
  NotificationTopicValues,
  ResponseValues,
} from "../../values/strings";
import { SimpleCarouselComponent } from "./SimpleCarouselComponent";
import { Flash } from "iconsax-react";
import { useThemeProvider } from "../../providers/ThemeProvider";

const AnnouncementCarouselComponent = () => {
  const coreRequest = useCoreRequestProvider();
  const theme = useThemeProvider();
  const [notifications, setNotifications] = React.useState(null);
  React.useEffect(async () => {
    if (!notifications) {
      const data = await coreRequest.get(
        LinkValues.core.provider.notifications.list(),
        {
          topic: NotificationTopicValues.announcement,
        }
      );
      setNotifications((data.data && data.data.data) || null);
    }
  }, [notifications]);

  return (
    <Box
      paddingY={2}
      paddingX={3}
      className={theme.styles.classes.secondaryBackground}
    >
      {(notifications && (
        <Stack direction="row" spacing={2}>
          <Flash
            size={18}
            className={theme.styles.classes.componentsCarouselAnnouncementFlash}
          />
          <Box />
          <SimpleCarouselComponent
            autoplay={true}
            autoplayDelay={3000}
            vertical={true}
            classname="announcementCarouselComponent"
          >
            {notifications.map((item, i) => (
              <SwiperSlide
                key={i}
                className={theme.styles.classes.componentsCarouselAnnouncement}
              >
                <a
                  href={item[ResponseValues.referredLink]}
                  style={{ width: "100%" }}
                >
                  {item[ResponseValues.title]}
                </a>
              </SwiperSlide>
            ))}
          </SimpleCarouselComponent>
        </Stack>
      )) || <Skeleton width="100%" animation="wave" />}
    </Box>
  );
};

export default AnnouncementCarouselComponent;
